/*
 * @Author: huangzq
 * @Date: 2019-09-27 11:34:33
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-06-17 15:03:46
 * @Desc: 营销资料-营销视频tab项
*/
<template>
  <div class="video-markting-tab">
    <!-- 视频上传oss的触发dom，它不会显示的 -->
    <mk-upload-oss
      v-show="false"
      ref="uploadRef"
      :bucket="$env.VUE_APP_ALI_OSS_BUCKET"
      :limit-size="100"
      accept=".mp4"
      @on-upload="videoUpload"
    >
      <span
        ref="ossTrigger"
        slot="trigger"
      />
    </mk-upload-oss>

    <!-- 视频上传进度弹窗 -->
    <video-progress-dialog
      :visible.sync="progressDialogShow"
      :upload-finished="fileUploadFinished"
      :progress="progress"
      :status="status"
      @on-close="onProgressDialogClose"
    />

    <!-- 搜索栏 -->
    <search-line @on-search="onSearch" />

    <div class="infinite-scroll-wrapper">
      <infinite-scroll
        ref="infiniteScroll"
        :api="api"
        @on-load-over="onLoadOver"
      >
        <!-- 列表内容 -->
        <div class="create-wrapper marketing-data-single-create-wrapper-209">
          <template v-if="isNeedCreateByTp">
            <div
              class="template-create"
              @click="templateCreateFun"
            >
              <mk-iconfont
                icon-class="xinzeng"
                class="plus-icon"
              />
              <div>模板创建</div>
            </div>
            <div
              class="empty-create"
              @click="emptyCreateFun"
            >
              空白创建
            </div>
          </template>
          <div
            v-else
            class="only-empty-create"
            @click="emptyCreateFun"
          >
            <mk-iconfont
              icon-class="xinzeng"
              class="plus-icon"
            />
            <div>创建营销视频</div>
          </div>
        </div>

        <item
          v-for="(item,index) in dataList"
          :key="item._id+item.status+item.updateTime"
          :item-data="item"
          :other-api="otherApi"
          :type="type"
          class="marketing-data-mk-data-item-209"
          @edit-item="editItem(index)"
          @delete-item="deleteItem(index)"
          @update-item="itemData=>updateItem(itemData,index)"
        />
      </infinite-scroll>
    </div>
  </div>
</template>

<script>
import { MKMATERIALSVC } from '@api'

import SearchLine from '../common/search-line'
import InfiniteScroll from '@components/infinite-scroll'
import Item from '../common/item'

import VideoProgressDialog from './progress-dialog/video-progress-dialog'

export default {
  name: 'VideoMarktingTab',
  components: { SearchLine, InfiniteScroll, Item, VideoProgressDialog },
  data () {
    return {
      type: 'video-markting',
      // * 获取列表的接口的相关数据
      api: {
        // 接口名称
        promiseFun: MKMATERIALSVC.VideoApi.videoListPost,
        // 接口参数；分页参数已经放在infiniteScroll组件里面了，所以这块写除了分页的其他参数
        params: {
          showTags: true
        }
      },

      // 其他接口
      otherApi: {
        delete: MKMATERIALSVC.VideoApi.videoDelete,
        publish: MKMATERIALSVC.VideoApi.videoCreatePost,
        update: MKMATERIALSVC.VideoApi.videoCreatePost,
        find: MKMATERIALSVC.VideoApi.videoDetailGet,
        statistics: MKMATERIALSVC.MaterialreportApi.reportBaseDataViewGet
      },

      // * 数据列表
      dataList: [],

      // * 当前某块video数据
      currBrochureItem: {},

      // * 是否需要模板创建
      isNeedCreateByTp: false,

      // * 是否显示video上传进度弹窗
      progressDialogShow: false,

      // * video文件是否上传完毕
      fileUploadFinished: false,

      // video上传的进度
      progress: 0,
      // video上传的结果
      status: 'progress'
    }
  },

  activated () {
    window.sessionStorage.removeItem('video-markting-cover')
    window.sessionStorage.removeItem('video-markting-url')
  },

  methods: {
    // * 搜索事件：返回最新的搜索条件值，然后执行infinite-scroll组件的获取列表方法
    onSearch (searchParams) {
      this.dataList = []
      this.$refs.infiniteScroll.resetPage(searchParams)
    },

    // * 滚动加载数据完毕，返回新获取的数据
    onLoadOver (list) {
      this.dataList.push(...list)
    },

    /**
     * * 模板创建点击：跳转到【官方模板页面】-无
     */
    templateCreateFun () {
      sessionStorage.setItem('official-template-library-tab-name', this.type)

      this.$router.push({
        path: '/marketing-content/official-template-library'
      })
    },

    // * 空白创建：在新标签页 打开 {营销视频编辑器}
    emptyCreateFun () {
      this.$refs.ossTrigger.click()
    },

    // 视频上传事件
    videoUpload (res) {
      const { type, file } = res

      if (type === 'before') {
        // !文件上传之前，处理以下内容

        this.progressDialogShow = true
        this.progress = 0
        this.status = 'progress'
      } else if (['progress', 'success', 'fail'].includes(type)) {
        // !文件上传中、上传成功、上传失败时，处理以下内容

        this.status = type

        if (type === 'progress') {
          // 文件上传中
          this.progress = Math.ceil(res.result.progress * 100)
        } else {
          // 上传成功、上传失败

          if (type === 'success') {
            // 上传成功
            const { url } = res.result

            const cover = this.util.getVideoClip(url, { width: 100 })

            window.sessionStorage.setItem('video-markting-cover', cover)
            window.sessionStorage.setItem('video-markting-url', url)
          }

          this.imagesFileUploadFinish()
        }
      }
    },

    // 所有图片文件都上传结束了，调用该方法
    imagesFileUploadFinish () {
      this.fileUploadFinished = true

      // 上传完成后，2s后自动关闭弹窗
      setTimeout(() => {
        this.progressDialogShow = false
        this.onProgressDialogClose()
      }, 2000)
    },

    // pdf进度弹窗关闭事件
    onProgressDialogClose () {
      this.$router.push({
        path: '/marketing-content/marketing-data/video-markting/create'
      })

      // this.$refs.uploadRef.$children[0].clearFiles()
    },

    // * 编辑某个营销视频：新标签页打开 {营销视频编辑器}
    editItem (index) {
      const { _id } = this.dataList[index]

      this.$router.push({
        path: '/marketing-content/marketing-data/video-markting/edit',
        query: { _id }
      })
    },

    // * 删除某个营销视频：通过index，使用Array.splice来删除
    deleteItem (index) {
      this.dataList.splice(index, 1)
    },

    /**
     * * 更新某个营销视频数据：
     * * 有id时：通过id获取最新的数据，然后再更新
     * * 无id时：使用传递过来的数据更新
     */
    async updateItem (itemData, index) {
      if (itemData._id) {
        // 通过接口，重新获取当前id的最新数据
        const res = await this.otherApi.find({
          _id: itemData._id
        })

        if (res.success) {
          // 将最新数据放到对应下标的dataList中
          this.$set(this.dataList, index, res.data)
        }
      } else {
        // 不通过接口，更新某个数据
        // 主要针对于状态的改变
        const newItemData = { ...this.dataList[index], ...itemData }
        this.$set(this.dataList, index, newItemData)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.video-markting-tab {
  .infinite-scroll-wrapper {
    flex: 1;
    overflow: hidden;

    .infinite-scroll {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      overflow: auto;
      padding: 0 20px;

      & > div {
        margin-right: 24px;
        margin-bottom: 24px;
      }

      .create-wrapper {
        .template-create {
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          width: 260px;
          height: 260px;
          margin-bottom: 24px;

          .plus-icon {
            font-size: 26px;
            margin-bottom: 18px;
          }
        }

        .empty-create {
          line-height: 58px;
          height: 58px;
          text-align: center;
        }

        .only-empty-create {
          height: 346px;
          margin-bottom: 0;
          box-sizing: border-box;

          @extend .template-create;
        }

        & > div {
          border: 1px dashed #d9d9d9;
          background-color: #fafafa;
          color: #595959;
          font-size: 14px;

          @extend .cursor;
        }
      }
    }
  }
}
</style>
